import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GetClaimEmailStatusRequestParams {
  claimKey: number;
}

export interface ClaimEmailStatusResponse {
  claimEmails: unknown[];
}

export const getClaimEmailStatusAPI = (params: GetClaimEmailStatusRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      claimKey: params.claimKey,
    },
    url: `${API.LOSS_AND_DAMAGE}/GetClaimEmailNotification`,
  });
};

export const fetchClaimEmailStatus = async (
  params: GetClaimEmailStatusRequestParams,
): Promise<ClaimEmailStatusResponse> => {
  const response: AxiosResponse<ClaimEmailStatusResponse> = await getClaimEmailStatusAPI(params);
  return response.data;
};
